import { render, staticRenderFns } from "./HomeSelection.vue?vue&type=template&id=1f84a29c&"
import script from "./HomeSelection.vue?vue&type=script&lang=js&"
export * from "./HomeSelection.vue?vue&type=script&lang=js&"
import style0 from "./HomeSelection.vue?vue&type=style&index=0&id=1f84a29c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports